import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { getAuthToken, isTokenExpired, getUserType, logout } from "../../utility/auth";



export default function Login() {
    const [uname, unamechange] = useState("");
    const [pass, passchange] = useState("");
    const [keepLoggedIn, setKeepLoggedIn] = useState(false); // State for "Keep Me Logged In"
    const navigate = useNavigate();
const handleSubmit = (e) => {
  e.preventDefault();
  const empdata = { uname, pass };

  axios.post("/login", empdata)
    .then((res) => {
      if (res.status === 200) {
        const data = res.data;
        if (data.token) {
          const token = data.token;
          const usertype = data.data.type.toLowerCase(); // Normalize to lowercase
          const expirationTime = Date.now() + 3 * 60 * 60 * 1000; // 3 hours

          if (keepLoggedIn) {
            localStorage.setItem("token", token);
            localStorage.setItem("expirationTime", expirationTime);
            localStorage.setItem("uname", data.data.uname);
            localStorage.setItem("usertype", usertype); // Store normalized usertype
          } else {
            sessionStorage.setItem("token", token);
            sessionStorage.setItem("expirationTime", expirationTime);
            sessionStorage.setItem("uname", data.data.uname);
            sessionStorage.setItem("usertype", usertype); // Store normalized usertype
          }

          toast.success("Logged in Successfully");

          // Add delay before redirect
          setTimeout(() => {
            console.log("Redirecting user with type:", usertype); // Debug log
            if (usertype === "admin") {
              navigate("/dashboard/analytics", { replace: true });
            } else if (usertype === "account") {
              navigate("/dashboard/account", { replace: true });
            } else if (usertype === "cashier") {
              navigate("/dashboard/cashier", { replace: true }); // Use existing cashier dashboard
            } else if (usertype === "manager") {
              navigate("/dashboard/admin", { replace: true }); // Redirect managers to admin dashboard
            } else {
              console.warn("Unknown user type:", usertype);
              navigate("/dashboard/admin", { replace: true }); // Default fallback to admin dashboard
            }
          }, 1000); // Increased delay

        } else {
          toast.error("Wrong username/Password");
        }
      } else if (res.status === 401) {
        toast.error("Wrong username/Password");
      }
    })
    .catch((err) => {
      toast.error("Wrong username/Password");
      console.log(err.message);
    });
};
useEffect(() => {
  const token = getAuthToken();
  const userType = getUserType();
  console.log("Token:", token);
  console.log("Is expired:", isTokenExpired());
  console.log("User type:", userType);

  if (token && !isTokenExpired()) {
    const normalizedUserType = userType?.toLowerCase();
    console.log("Normalized user type:", normalizedUserType);
    
    switch (normalizedUserType) {
      case "admin":
        navigate("/dashboard/analytics", { replace: true });
        break;
      case "account":
        navigate("/dashboard/account", { replace: true });
        break;
      case "cashier":
        navigate("/dashboard/cashier", { replace: true }); // Use existing cashier dashboard
        break;
      case "manager":
        navigate("/dashboard/analytics", { replace: true }); // Redirect managers to analytics dashboard
        break;
      default:
        console.warn("Unknown user type, staying on login");
        logout(); // Clear invalid session
        break;
    }
  }
}, [navigate]);

    return (
        <>
            <ToastContainer />
            <div className="login-page" style={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #d90429 0%, #222 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px',
                fontFamily: '"Segoe UI", Roboto, Arial, sans-serif',
                position: 'relative',
                overflow: 'hidden'
            }}>
                {/* Amusement Park Theme Background */}
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundImage: `
                        radial-gradient(circle at 15% 15%, rgba(255,255,255,0.12) 0%, transparent 60%),
                        radial-gradient(circle at 85% 85%, rgba(255,255,255,0.12) 0%, transparent 60%),
                        url('https://img.icons8.com/color/96/000000/ferris-wheel.png'),
                        url('https://img.icons8.com/color/96/000000/roller-coaster.png')
                    `,
                    backgroundRepeat: 'no-repeat, no-repeat, no-repeat, no-repeat',
                    backgroundPosition: '10% 10%, 90% 90%, 5% 80%, 95% 20%',
                    pointerEvents: 'none',
                    opacity: 0.15
                }} />
                <div className="login-container" style={{
                    position: 'relative',
                    zIndex: 1,
                    width: '100%',
                    maxWidth: '1100px',
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    borderRadius: '24px',
                    overflow: 'hidden',
                    boxShadow: '0 25px 50px rgba(217, 4, 41, 0.15)',
                    background: 'rgba(255, 255, 255, 0.97)',
                    backdropFilter: 'blur(10px)',
                    minHeight: '600px',
                    border: '3px solid #d90429'
                }}>
                    {/* Left Column - Login Form */}
                    <div className="login-form-section" style={{
                        padding: '60px 50px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        background: 'rgba(255, 255, 255, 0.98)'
                    }}>
                        <div className="form-header" style={{ textAlign: 'center', marginBottom: '40px' }}>
                            <div style={{
                                width: '90px',
                                height: '90px',
                                background: 'linear-gradient(135deg, #d90429 0%, #222 100%)',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                margin: '0 auto 20px',
                                boxShadow: '0 10px 30px rgba(217, 4, 41, 0.25)'
                            }}>
                                <img src="https://img.icons8.com/color/96/000000/ferris-wheel.png" alt="Ferris Wheel" style={{ width: '60px', height: '60px' }} />
                            </div>
                            <h1 style={{
                                fontSize: '2.7rem',
                                fontWeight: '800',
                                color: '#d90429',
                                margin: '0 0 8px 0',
                                letterSpacing: '2px',
                                textShadow: '2px 2px 0 #fff, 4px 4px 0 #222'
                            }}>Park Login</h1>
                            <p style={{
                                color: '#222',
                                fontSize: '1.15rem',
                                margin: 0,
                                fontWeight: '600',
                                textShadow: '1px 1px 0 #fff'
                            }}>Welcome to Amusement Park Portal</p>
                        </div>

                        <form className="login-form" onSubmit={handleSubmit} style={{ width: '100%' }}>
                            <div className="form-group" style={{ marginBottom: '25px' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '8px',
                                    fontSize: '1.05rem',
                                    fontWeight: '600',
                                    color: '#d90429',
                                    letterSpacing: '1px'
                                }}>User ID</label>
                                <div style={{ position: 'relative' }}>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        id="uname"
                                        value={uname}
                                        onChange={(e) => unamechange(e.target.value)}
                                        placeholder="Enter your username"
                                        style={{
                                            width: '100%',
                                            padding: '15px 20px 15px 50px',
                                            border: '2px solid #d90429',
                                            borderRadius: '14px',
                                            fontSize: '1.05rem',
                                            transition: 'all 0.3s ease',
                                            backgroundColor: '#fff',
                                            outline: 'none',
                                            color: '#222',
                                            boxShadow: '0 2px 8px rgba(217, 4, 41, 0.08)'
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = '#222';
                                            e.target.style.backgroundColor = '#fff';
                                            e.target.style.boxShadow = '0 0 0 3px rgba(217, 4, 41, 0.12)';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = '#d90429';
                                            e.target.style.backgroundColor = '#fff';
                                            e.target.style.boxShadow = 'none';
                                        }}
                                    />
                                    <i className="fas fa-user" style={{
                                        position: 'absolute',
                                        left: '18px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: '#d90429',
                                        fontSize: '1.2rem'
                                    }}></i>
                                </div>
                            </div>

                            <div className="form-group" style={{ marginBottom: '25px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                    <label style={{
                                        fontSize: '1.05rem',
                                        fontWeight: '600',
                                        color: '#d90429',
                                        letterSpacing: '1px'
                                    }}>Password</label>
                                    <Link to="/forgot-password" style={{
                                        fontSize: '0.95rem',
                                        color: '#222',
                                        textDecoration: 'underline',
                                        fontWeight: '600'
                                    }}>Forgot password?</Link>
                                </div>
                                <div style={{ position: 'relative' }}>
                                    <input
                                        type="password"
                                        className="form-control"
                                        required
                                        id="pass"
                                        value={pass}
                                        onChange={(e) => passchange(e.target.value)}
                                        placeholder="Enter your password"
                                        style={{
                                            width: '100%',
                                            padding: '15px 20px 15px 50px',
                                            border: '2px solid #d90429',
                                            borderRadius: '14px',
                                            fontSize: '1.05rem',
                                            transition: 'all 0.3s ease',
                                            backgroundColor: '#fff',
                                            outline: 'none',
                                            color: '#222',
                                            boxShadow: '0 2px 8px rgba(217, 4, 41, 0.08)'
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = '#222';
                                            e.target.style.backgroundColor = '#fff';
                                            e.target.style.boxShadow = '0 0 0 3px rgba(217, 4, 41, 0.12)';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = '#d90429';
                                            e.target.style.backgroundColor = '#fff';
                                            e.target.style.boxShadow = 'none';
                                        }}
                                    />
                                    <i className="fas fa-lock" style={{
                                        position: 'absolute',
                                        left: '18px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: '#d90429',
                                        fontSize: '1.2rem'
                                    }}></i>
                                </div>
                            </div>

                            <div className="form-group" style={{ marginBottom: '30px' }}>
                                <label style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    fontSize: '1rem',
                                    color: '#222',
                                    fontWeight: '600'
                                }}>
                                    <input
                                        type="checkbox"
                                        checked={keepLoggedIn}
                                        onChange={() => setKeepLoggedIn(!keepLoggedIn)}
                                        style={{
                                            marginRight: '12px',
                                            width: '18px',
                                            height: '18px',
                                            cursor: 'pointer',
                                            accentColor: '#d90429'
                                        }}
                                    />
                                    Keep me logged in
                                </label>
                            </div>

                            <button 
                                type="submit" 
                                style={{
                                    width: '100%',
                                    padding: '15px',
                                    background: 'linear-gradient(135deg, #d90429 0%, #222 100%)',
                                    border: 'none',
                                    borderRadius: '14px',
                                    color: 'white',
                                    fontSize: '1.15rem',
                                    fontWeight: '700',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    boxShadow: '0 4px 15px rgba(217, 4, 41, 0.25)',
                                    transform: 'translateY(0)',
                                    letterSpacing: '1px',
                                    textShadow: '1px 1px 0 #222'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 6px 20px rgba(217, 4, 41, 0.35)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 4px 15px rgba(217, 4, 41, 0.25)';
                                }}
                            >
                                Enter Park
                            </button>
                        </form>
                    </div>

                    {/* Right Column - Feature Showcase */}
                    <div className="feature-section" style={{
                        background: 'linear-gradient(135deg, #222 0%, #d90429 100%)',
                        padding: '60px 50px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        color: 'white',
                        position: 'relative',
                        overflow: 'hidden',
                        borderLeft: '4px solid #d90429'
                    }}>
                        {/* Background Pattern */}
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundImage: `
                                radial-gradient(circle at 30% 30%, rgba(255,255,255,0.1) 0%, transparent 50%),
                                radial-gradient(circle at 70% 70%, rgba(255,255,255,0.1) 0%, transparent 50%)
                            `,
                            pointerEvents: 'none'
                        }} />
                        
                        <div style={{ position: 'relative', zIndex: 1 }}>
                            <h2 style={{
                                fontSize: '2.5rem',
                                fontWeight: '800',
                                marginBottom: '20px',
                                textAlign: 'center',
                                color: '#fff',
                                textShadow: '2px 2px 0 #d90429, 4px 4px 0 #222'
                            }}>
                                🎡 Welcome to the Fun Zone! 🎢
                            </h2>
                            <p style={{
                                fontSize: '1.25rem',
                                marginBottom: '40px',
                                textAlign: 'center',
                                opacity: 0.95,
                                color: '#fff',
                                fontWeight: '600',
                                textShadow: '1px 1px 0 #d90429'
                            }}>
                                Enter your credentials to access the Amusement Park dashboard
                            </p>
                            
                            <div className="features-list" style={{ marginTop: '40px' }}>
                                {[ 
                                    { icon: 'fas fa-ticket-alt', title: 'Ticketing', desc: 'Fast entry with digital tickets!' },
                                    { icon: 'fas fa-ice-cream', title: 'Food & Snacks', desc: 'Order delicious treats from anywhere!' },
                                    { icon: 'fas fa-child', title: 'Kids Zone', desc: 'Special fun for little ones!' },
                                    { icon: 'fas fa-magic', title: 'Live Shows', desc: 'Enjoy magic, music, and more!' }
                                ].map((feature, index) => (
                                    <div key={index} style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginBottom: '25px',
                                        padding: '15px',
                                        background: 'rgba(217, 4, 41, 0.08)',
                                        borderRadius: '14px',
                                        backdropFilter: 'blur(10px)',
                                        boxShadow: '0 2px 8px rgba(217, 4, 41, 0.08)'
                                    }}>
                                        <div style={{
                                            width: '50px',
                                            height: '50px',
                                            background: 'rgba(255, 255, 255, 0.25)',
                                            borderRadius: '14px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '15px',
                                            flexShrink: 0
                                        }}>
                                            <i className={feature.icon} style={{ fontSize: '1.5rem', color: '#fff', textShadow: '1px 1px 0 #d90429' }}></i>
                                        </div>
                                        <div>
                                            <h4 style={{ margin: '0 0 5px 0', fontSize: '1.15rem', fontWeight: '700', color: '#fff', textShadow: '1px 1px 0 #d90429' }}>
                                                {feature.title}
                                            </h4>
                                            <p style={{ margin: 0, fontSize: '0.95rem', opacity: 0.9, color: '#fff' }}>
                                                {feature.desc}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* Mobile Responsive Styles */}
                <style jsx>{`
                    @media (max-width: 768px) {
                        .login-container {
                            grid-template-columns: 1fr !important;
                            max-width: 400px !important;
                        }
                        .feature-section {
                            display: none !important;
                        }
                        .login-form-section {
                            padding: 40px 20px !important;
                        }
                    }
                `}</style>
            </div>
        </>
    );
}
